import { BadgeCommonProps } from "@certn/cascadia/components/badge/types";

import { _Badge } from "./_Badge";

export function NeutralBadge(props: BadgeCommonProps) {
  const {
    type = "bold",
    testID = "danger-badge",
    size = "large",
    ...rest
  } = props;

  if (type === "bold")
    return (
      <_Badge
        fill="background-accent-neutral-strong"
        color="text-inverse"
        testID={testID}
        size={size}
        {...rest}
      />
    );

  return (
    <_Badge
      fill="background-accent-neutral-weak"
      color="text-base"
      testID={testID}
      size={size}
      {...rest}
    />
  );
}
